import React, { Component, createRef } from 'react'
import './ani.less'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage, isRtl } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import { unix2date6 } from 'src/helper/time'
import { jumpToWallet, closeWebview, closeWebViewPage } from 'src/helper/webviewFun'

// import debounce from 'lodash/debounce'

import ResultPopUp from './ResultPopUp'
import RewardView from './RewardView'
import RankView from './RankView'
import ToastColor from '../../../component/ToastColor'
import LoadingComp from './LoadingComp'

@inject('store')
@observer

export default class extends Component {
  constructor(props) {
    super(props)
    this.eggStore = this.props.store.register('app/geshapon')
  }

  state = {
    // 开始动画控制
    position: 0,
    position2: 0,
    isSwitch: false,
    isStart: false,
    isLoading: false,  // 开新局防抖
    isFall: false,
    isShake: false,
    isShowResult: false,

    // 池子等级
    poolLevel: 1,
    poolLevelShow: 1,
    // 每个功能状态（规则，商店，抽奖记录，排行）
    funcState: 0,
    // 商店物品弹框
    shopReminder: 0,
    // 是否中大奖显示控制
    isBigPrize: false,
    // 是否中大奖接口控制
    isBigPrizeMain: false,

    // 排行列表
    rankingList: [],
    // 结果列表
    resultList: [],
    // 商店列表
    shopList: [],

    // 用户金币
    userGold: 0,
    // 概率
    prob: 0,
    // 碎片
    chip: -1,
    // 大奖图片
    bigPrizeImage: "https://img.chatie.live/app/gift/gift_egg_Mermaid.png",
    // 连抽次数
    times: 10,
    // 下落蛋颜色
    eggColor: "",


    // 商店物品展示图片
    shopGiftImage: "",
    // 商店商品id
    eggShopId: 0,
    // 商店商品价格
    currentGoodsPrice: 0,

    // 两种记录
    recordState: 1,
    // 1.抽奖记录是否更多
    isMore: false,
    historyScroll: "",
    // 抽奖历史列表
    historyList: [],
    // 2.商店兑换记录是否更多
    isExMore: false,
    shopHistoryScroll: "",
    // 兑换历史列表
    exchangeRecordList: [],

    // error 文字提示
    popUpTips: "",
    popUpColor: "",

    // 初始化页面加载
    loadingPopUp: false,

    // 历史记录防抖
    isCanMore: true,

    loadGif: false,

    handFirstShow: true,

    normalList: [],
    deluxeList: [],

    playMusic: false,
    moreloading: false,
    lang:langM.en,
    language:'en',
  }

  async componentDidMount() {
    setDocumentTitle(this.state.lang.pageTitle)
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlang(language)
    const pos = isRtl(language) ? '2.1rem' : '0'
    this.setState({
      lang: setlang(language, langM),
      language: language,
      position: pos,
      position2: pos
    })
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
  }

  RunOnStart = async (uid) => {
    this.setState({
      uid: uid,
      loadingPopUp: true
    })

    try {
      // 初始化 
      // 排名 -> 奖励 - 用户金币 - 概率 - 商店列表 
      let rank = await this.eggStore.getRanking()
      let rewardLow = await this.eggStore.getRewardList(1)
      let rewardHigh = await this.eggStore.getRewardList(2)
      let gold = await this.eggStore.getUserGold()
      let prob = await this.eggStore.getProb()
      let shopList = await this.eggStore.getShopList()
      this.setState({
        rankingList: rank && rank.res && rank.res.list,
        userGold: gold && gold.res && gold.res.gold,
        prob: prob && prob.res,
        shopList: shopList && shopList.res,
        loadingPopUp: false,
        normalList: rewardLow && rewardLow.res,
        deluxeList: rewardHigh && rewardHigh.res
      })
    } catch (error) {
      console.log(error)
      this.onClickPopUp(this.state.lang.nw, "rgba(0,0,0,.6)")
      return new Error(error)
    }
  }

  // 切换池子等级
  changePoolLevel(val, flag) {
    const { language } = this.state
    // flag 区分 - 池子模式 or 奖品展示
    if (flag) {
      // 查看奖池切换
      if (val == 1) {
        if (isRtl(language)) {
          this.setState({
            position2: '2.1rem'
          })
        } else {
          this.setState({
            position2: '0'
          })
        }
      }
      if (val == 2) {
        if (isRtl(language)) {
          this.setState({
            position2: '0'
          })
        } else {
          this.setState({
            position2: '2.1rem'
          })
        }
      }
      this.setState({
        poolLevelShow: val
      })
    } else {
      // 奖池模式切换
      if (val == 1) {
        if (isRtl(language)) {
          this.setState({
            position: '2.1rem'
          })
        } else {
          this.setState({
            position: '0'
          })
        }
      }
      if (val == 2) {
        if (isRtl(language)) {
          this.setState({
            position: '0'
          })
        } else {
          this.setState({
            position: '2.1rem'
          })
        }
      }
      this.setState({
        poolLevel: val
      })
    }
  }

  // 概率金额调试
  async testEgg(x, y) {
    let res = await this.eggStore.goBet(x, y)
    let total = 0
    let totalList = res.res.list.map((item) => {
      return item.winNum * item.gold
    })
    totalList.map((item) => {
      total += item
    })
    console.log(total, 'tt')
    console.log(totalList, 'tt')
  }

  // 开始扭蛋
  async canBet() {
    try {
      this.setState({
        loadGif: true,
        handFirstShow: false
      })
      let res = await this.eggStore.goBet(this.state.poolLevel, this.state.times)
      if (!res) {
        return false
      }
      // gold开始
      if (this.state.playMusic) {
        this.audioValue2.currentTime = 0
        this.audioValue2.play()
      }
      await this.setState({
        resultList: res.res.list,
        isBigPrizeMain: res.res.bigResult.isBetBig,
        bigPrizeImage: res.res.bigResult.image,
        prob: res.res.probability,
        loadGif: false
      })

      let color = await this.getEggColor()

      this.setState({
        eggColor: color
      })

      let gold = 0
      if (this.state.poolLevel == 1) {
        gold = 10
      } else if (this.state.poolLevel == 2) {
        gold = 100
      }
      this.setState({
        userGold: this.state.userGold - (this.state.times * gold)
      })
      // bg开始
      if (this.state.playMusic) {
        this.audioValue.currentTime = 0
        this.audioValue.play()
      }
      return true
    } catch (error) {
      this.onClickPopUp("网络繁忙", "rgba(0,0,0,.6)")
      return new Error(error)
    }
  }

  // 动画效果
  async onSwitch() {
    // 阀门
    if (this.state.isLoading) {
      return
    }

    this.setState({
      // 开启阀门
      isLoading: true
    })

    // 金币不够判断
    let multiple = this.state.poolLevel == 1 ? 10 : 100
    if (this.state.userGold - multiple * this.state.times < 0) {
      this.onClickPopUp(this.state.lang.noG, "rgba(0,0,0,.6)")
      this.setState({
        // 关闭阀门
        isLoading: false
      })
      return
    }

    // 计算蛋时长
    let time = 0
    if (this.state.times == 10) {
      time = 6500
    } else if (this.state.times == 50) {
      time = 6500
    }

    // 收集类型和次数，请求接口，等待结果
    // 根据结果渲染页面
    let res = await this.canBet()

    if (!res) {
      this.setState({
        // 关闭阀门
        isLoading: false
      })
      this.onClickPopUp(this.state.lang.nw, "rgba(0,0,0,.6)")
      return
    }


    this.setState({
      // 按钮动画
      isSwitch: true,
    })

    // 两秒后球开始转动
    setTimeout(() => {
      this.setState({
        isStart: true
      })
    }, 2000);

    // 球动画需要多少秒结束
    setTimeout(() => {
      this.setState({
        // 球动画结束
        isStart: false,
        // 球下落
        isFall: true
      })
      setTimeout(() => {
        this.setState({
          // 抖动
          isShake: true
        })
        // 结果
        setTimeout(() => {
          this.setState({
            // 阀门关闭，可进行下一局游戏
            isLoading: false,
            // 清除球下落
            isFall: false,
            // 清除抖动
            isShake: false,
            // 清除按钮
            isSwitch: false,
            // 显示结果
            isShowResult: true,
            // 是否中大奖？
            isBigPrize: this.state.isBigPrizeMain,
          })
          setTimeout(() => {
            if (this.state.playMusic) {
              this.audioValue2.currentTime = 0
              this.audioValue2.pause()
            }
          }, 2000);
        }, 1000);
      }, 1000);
    }, time);

  }

  async onChangeFuncState(val) {
    this.setState({
      funcState: val
    })

    // 关闭商店物品弹框
    if (val == 0) {
      this.setState({
        shopReminder: 0
      })
    }

    // 历史记录
    if (val == 1) {
      let record = await this.eggStore.getRecord()
      let exRecordList = await this.eggStore.getExRecordList()
      this.setState({
        // 抽奖记录
        isMore: record.res.hasMore,
        historyScroll: record.res.scroll,
        historyList: record.res.list,
        // 兑换记录
        isExMore: exRecordList.res.hasMore,
        shopHistoryScroll: exRecordList.res.scroll,
        exchangeRecordList: exRecordList.res.list,
      })
    }

    // 商店
    if (val == 3) {
      let chip = await this.eggStore.getChip()
      this.setState({
        chip: chip.res
      })
    }
    if (val == 5) {
      let rank = await this.eggStore.getRanking()
      this.setState({
        rankingList: rank.res.list
      })
    }
  }

  // 商店礼物弹框
  isShowShop(val, img, id, price) {
    // 设置 - 图片，商品id，价格
    this.setState({
      shopReminder: val,
      shopGiftImage: img,
      eggShopId: id,
      currentGoodsPrice: price
    })
  }

  // 兑换礼物
  async exchangeGift(id, count) {
    // 不够碎片提示
    if (this.state.chip - this.state.currentGoodsPrice < 0) {
      this.onClickPopUp(this.state.lang.noF, "rgba(0,0,0,.6)")
      return
    }
    this.onClickPopUp(this.state.lang.exSuc, "#7d35ff")
    this.setState({
      shopReminder: 0,
      chip: this.state.chip - this.state.currentGoodsPrice
    })
    let exRes = await this.eggStore.canExchange(id, 1)
  }

  // 获取更多历史记录
  async getMore(val) {
    // 防抖。防止多次点击
    if (!this.state.isCanMore) {
      return
    }
    this.setState({
      isCanMore: false,
      moreloading: true
    })
    if (val == 1 && this.state.isMore) {
      let rc = await this.eggStore.getRecord(this.state.historyScroll)
      let arr = this.state.historyList
      rc.res.list.map((item) => {
        arr.push(item)
      })
      this.setState({
        isMore: rc.res.hasMore,
        historyScroll: rc.res.scroll,
        historyList: arr,
        isCanMore: true,
        moreloading: false
      })
    }

    if (val == 2 && this.state.isExMore) {
      let rc = await this.eggStore.getExRecordList(this.state.shopHistoryScroll)
      let arr = this.state.exchangeRecordList
      rc.res.list.map((item) => {
        arr.push(item)
      })
      this.setState({
        isExMore: rc.res.hasMore,
        shopHistoryScroll: rc.res.scroll,
        exchangeRecordList: arr,
        isCanMore: true,
        moreloading: false
      })
    }
  }


  // 下落蛋颜色控制
  getEggColor() {
    let arr = []
    let max = 0
    this.state.resultList.map((item) => {
      arr.push(item.gold)
    })
    max = Math.max.apply(null, arr)
    if (this.state.poolLevel == 1) {
      if (max >= 100) {
        return 'egg-gold'
      } else if (max >= 5 && max < 100) {
        return 'egg-purple'
      } else if (max == 1) {
        return 'egg-blue'
      }
    } else if (this.state.poolLevel == 2) {
      if (max >= 300) {
        return 'egg-gold'
      } else if (max >= 100 && max <= 200) {
        return 'egg-purple'
      } else if (max < 100) {
        return 'egg-blue'
      }
    }
  }
  // 历史记录弹框
  onChangeRecord(val) {
    this.setState({
      recordState: val
    })
  }
  // 改变抽奖次数
  onChangeTimes(val) {
    this.setState({
      times: val
    })
  }
  // 扭蛋机结果弹框
  onChangeIsShowResult(val) {
    this.setState({
      isShowResult: val
    })
  }
  // 控制提示框
  onClickPopUp(txt, color) {
    this.setState({
      popUpTips: txt,
      popUpColor: color
    })
    this.refs.toast.hideRule(true)
  }
  // 改变播放
  async changePlay() {
    if (!this.state.playMusic) {
      await this.setState({
        playMusic: true
      })
    } else {
      await this.setState({
        playMusic: false
      })
    }
    if (this.state.playMusic) {
      this.audioValue.play()
    } else {
      this.audioValue.pause()
    }
  }

  closeWebviewShow() {
    closeWebview()
    closeWebViewPage()
  }

  // 大奖组件
  jackPotHeaderComp = () => {
    return (
      <div className="jackpot-main-wrap">
        <div className="jackpot-rank-main">
          <img className="jackpot-pic" src="/img/app/gashapon/jackpot.png" alt="" />
          <div className="jackpot-rank">
            <img className="avatar"
              src={this.state.rankingList.length > 0 && this.state.rankingList[0].avatarurl || "/img/de_img_logo.png"} alt="" />
            <div
              className="desc"
              onClick={() => { this.onChangeFuncState(5) }}>
              {this.state.lang.jackPotRankTitle}
            </div>
          </div>
        </div>
        <div className="jackpot-right">
          <div className="jackpot-rule-main" onClick={() => this.onChangeFuncState(4)}></div>
          <div className="jackpot-count-main">
            <div className="jackpot-gift">
              <div className="bubble"></div>
              <img className='gift' src={this.state.bigPrizeImage} alt="" />
            </div>
            <div className="jackpot-count">
              <div className="title" dangerouslySetInnerHTML={{ __html: this.state.lang.jackPotPro }}></div>
              <div className="count">{this.state.prob}%</div>
            </div>
          </div>
          <div className="jackpot-close-main" onClick={() => this.closeWebviewShow()}></div>
        </div>
      </div>
    )
  }

  // 扭蛋机主体部分
  gashaponContentMainComp = () => {
    return (
      <div className="gashapon-content-wrap">
        {/* 手 */}
        {this.state.handFirstShow && (<div className="hand"></div>)}

        {/* 普通高级模式切换 */}
        <div className="pool-mode-main">
          <div className="pool-mode">
            <div className="pool-active" style={{ backgroundPosition: `${this.state.position} center` }}></div>
            <div className="pool-txt">
              <div className="low-pool" onClick={() => this.changePoolLevel(1, false)}>{this.state.lang.poolL}</div>
              <div className="hight-pool" onClick={() => this.changePoolLevel(2, false)}>{this.state.lang.poolH}</div>
            </div>
          </div>
        </div>

        {/* 扭蛋机主体内部 */}
        <div className="gashapon-machine">
          {/* 规则 */}
          <div className="gashapon-rule" onClick={() => { this.onChangeFuncState(2) }}>
            {this.state.lang.rule}
          </div>
          {/* 商店 */}
          <div className="gashapon-shop" onClick={() => { this.onChangeFuncState(3) }}>
            <span>
              {this.state.lang.shop}
            </span>
          </div>
          {/* 奖励列表 */}
          <div className="gashapon-reward" onClick={() => { this.onChangeFuncState(6) }}>{this.state.lang.goodsList}</div>
          <div className="gold-record-box">
            {/* 金币查看 */}
            <div className="gashapon-gold">
              <div className="gold-main">
                <div className="gold-box">
                  <div className="gold-pic"></div>
                  <div className="gold-num">{(this.state.userGold)}</div>
                </div>
                <div className="gold-add" onClick={() => jumpToWallet()}></div>
              </div>
            </div>
            {/* 抽奖记录 */}
            <div className="gashapon-record" onClick={() => { this.onChangeFuncState(1) }}>{this.state.lang.record}</div>
          </div>
          {/* 选择次数 */}
          <div className={`gashapon-10 ${this.state.times == 10 ? 'gashapon-prize-active' : ''}`} onClick={() => { this.onChangeTimes(10) }}>
            {this.state.lang.ten}
            <br />
            <span>
              (
              {this.state.poolLevel == 1 && 10 * 10}
              {this.state.poolLevel == 2 && 10 * 100}
              <img src="/img/gold.png" alt="" style={{ width: '0.2rem', height: '0.2rem' }} />
              )
            </span>
          </div>
          <div className={`gashapon-50 ${this.state.times == 50 ? 'gashapon-prize-active' : ''}`} onClick={() => { this.onChangeTimes(50) }}>
            {this.state.lang.fifty}
            <br />
            <span>
              (
              {this.state.poolLevel == 1 && 50 * 10}
              {this.state.poolLevel == 2 && 50 * 100}
              <img src="/img/gold.png" alt="" style={{ width: '0.2rem', height: '0.2rem' }} />
              )
            </span>
          </div>
          {/* 掉落蛋 */}
          <div className="gashapon-egg">
            <div className={`egg ${this.state.eggColor} ${this.state.isFall ? 'egg-ani' : ''} ${this.state.isShake ? "egg-shake-ani" : ""}`}></div>
          </div>
          {/* 转扭按钮 */}
          <div className={`gashapon-switch ${this.state.isSwitch ? 'switch-ani' : ''}`} onClick={() => this.onSwitch()}></div>
        </div>


        {/* 普通扭蛋显示 */}
        <div
          className={`gashapon-egg-list ${this.state.poolLevel == 1 ? "egg-fade" : ""}`}
          style={{ display: `${this.state.poolLevel == 1 ? 'block' : 'none'}` }}>
          <div className={`egg-item01 ${this.state.isStart ? 'egg1-ani' : ''}`}></div>
          <div className={`egg-item02 ${this.state.isStart ? 'egg2-ani' : ''}`}></div>
          <div className={`egg-item03 ${this.state.isStart ? 'egg3-ani' : ''}`}></div>
          <div className={`egg-item04 ${this.state.isStart ? 'egg4-ani' : ''}`}></div>
          <div className={`egg-item05 ${this.state.isStart ? 'egg5-ani' : ''}`}></div>
          <div className={`egg-item06 ${this.state.isStart ? 'egg6-ani' : ''}`}></div>
          <div className={`egg-item07 ${this.state.isStart ? 'egg7-ani' : ''}`}></div>
          <div className={`egg-item08 ${this.state.isStart ? 'egg8-ani' : ''}`}></div>
          <div className={`egg-item09 ${this.state.isStart ? 'egg9-ani' : ''}`}></div>
          <div className={`egg-item10 ${this.state.isStart ? 'egg10-ani' : ''}`}></div>
        </div>

        {/* 高级扭蛋显示 */}
        <div
          className={`gashapon-egg-list ${this.state.poolLevel == 2 ? "egg-fade" : ""}`}
          style={{ display: `${this.state.poolLevel == 2 ? 'block' : 'none'}` }}>
          <div className={`egg-item001 ${this.state.isStart ? 'egg1-ani' : ''}`}></div>
          <div className={`egg-item002 ${this.state.isStart ? 'egg2-ani' : ''}`}></div>
          <div className={`egg-item003 ${this.state.isStart ? 'egg3-ani' : ''}`}></div>
          <div className={`egg-item004 ${this.state.isStart ? 'egg4-ani' : ''}`}></div>
          <div className={`egg-item005 ${this.state.isStart ? 'egg5-ani' : ''}`}></div>
          <div className={`egg-item006 ${this.state.isStart ? 'egg6-ani' : ''}`}></div>
          <div className={`egg-item007 ${this.state.isStart ? 'egg7-ani' : ''}`}></div>
          <div className={`egg-item008 ${this.state.isStart ? 'egg8-ani' : ''}`}></div>
          <div className={`egg-item009 ${this.state.isStart ? 'egg9-ani' : ''}`}></div>
          <div className={`egg-item010 ${this.state.isStart ? 'egg10-ani' : ''}`}></div>
        </div>

        {/* 拉杆 */}
        <div className={`gashapon-bar ${this.state.isSwitch ? 'bar-ani' : ''}`}></div>

      </div>
    )
  }

  // 弹框标题组件
  popUpTitleComp = () => {
    return (
      <div className="gashapon-reminder-title">
        {this.state.funcState == 1 ? this.state.lang.record : ''}
        {this.state.funcState == 2 ? this.state.lang.rule : ''}
        {this.state.funcState == 3 ? this.state.lang.shop : ''}
        {this.state.funcState == 4 ? this.state.lang.bigPrizeRule : ''}
        {this.state.funcState == 5 ? this.state.lang.rank : ''}
        {this.state.funcState == 6 ? this.state.lang.goodsList : ''}
      </div>
    )
  }

  // 抽奖、兑换记录组件
  recordComp = () => {
    return (
      <div className="record-content-main">
        {/* 抽奖记录、兑换记录切换 */}
        <div className="record-tab">
          <div className={`record-lottery ${this.state.recordState == 1 ? 'record-active' : ''}`}
            onClick={this.onChangeRecord.bind(this, 1)}>{this.state.lang.cjRc}</div>
          <div className={`record-exchange ${this.state.recordState == 2 ? 'record-active' : ''}`}
            onClick={this.onChangeRecord.bind(this, 2)}>{this.state.lang.exRc}</div>
        </div>
        {/* 抽奖记录 */}
        <div className={`record-content`} style={{ display: `${this.state.recordState == 1 ? 'block' : 'none'}` }}>
          {
            this.state.historyList.map((item, index) => {
              return (
                <div className="record-item" key={index}>
                  <div className="record-time">
                    <div className='time'>{unix2date6(item.ts)}</div>
                    {
                      item.ptype == 1 ?
                        (<div className='modeL'>({item.ptype == 1 && this.state.lang.poolL})</div>)
                        :
                        (<div className='modeH'>({item.ptype != 1 && this.state.lang.poolH})</div>)
                    }
                  </div>
                  <div className="record-table">
                    {/* 标题 */}
                    <div className="re-td">
                      <div className="record-desc">{this.state.lang.goods}</div>
                      <div className="h"></div>
                      <div className="record-count">{this.state.lang.count}</div>
                    </div>

                    {/* 大奖 */}
                    {
                      item.bigResult.isBetBig && (
                        <div className="re-td-big">
                          <div className="record-prize">
                            <div className="circle"></div>
                            <img src={item.bigResult.image} alt="" />
                          </div>
                          <div className="h"></div>
                          <div className="record-prize-num">1</div>
                        </div>
                      )
                    }

                    {
                      item.list.map((item2, index2) => {
                        return (
                          <div className="re-td" key={index2}>
                            <div className="record-pic">
                              <img src={item2.image}
                                style={{ transform: `${item2.image.indexOf('egg_fragment') > 0 ? 'scale(0.75)' : ''}` }} alt="" />
                            </div>
                            <div className="h"></div>
                            <div className="record-num">{item2.winNum}</div>
                          </div>
                        )
                      })
                    }

                  </div>
                </div>
              )
            })
          }
          {
            this.state.isMore ?
              (
                <div className="more" onClick={this.getMore.bind(this, 1)}>
                  {this.state.lang.seeMore}
                  {
                    this.state.moreloading && (
                      <div className="moreloading">
                        <img src="/img/other/loading.gif" alt="" />
                      </div>
                    )
                  }
                </div>
              )
              :
              (<div className="noMore">{this.state.lang.noMore}</div>)
          }
        </div>
        {/* 兑换记录 */}
        <div className={`record-content`} style={{ display: `${this.state.recordState == 2 ? 'block' : 'none'}` }}>
          {
            this.state.exchangeRecordList.map((item, index) => {
              return (
                <div className="record-item" key={index}>
                  <div className="record-time">
                    <div className='time'>{unix2date6(item.ts)}</div>
                  </div>
                  <div className="record-table">
                    {/* 标题 */}
                    <div className="re-td">
                      <div className="record-desc">{this.state.lang.gf}</div>
                      <div className="h"></div>
                      <div className="record-count">{this.state.lang.count}</div>
                    </div>

                    <div className="re-td">
                      <div className="record-pic">
                        <img src={item.image}
                          style={{ transform: `${item.image.indexOf('egg_fragment') > 0 ? 'scale(0.75)' : ''}` }} alt="" />
                      </div>
                      <div className="h"></div>
                      <div className="record-num">{item.count}</div>
                    </div>

                  </div>
                </div>
              )
            })
          }


          {
            this.state.isExMore ?
              (
                <div className="more" onClick={this.getMore.bind(this, 2)}>
                  {this.state.lang.seeMore}
                  {
                    this.state.moreloading && (
                      <div className="moreloading">
                        <img src="/img/other/loading.gif" alt="" />
                      </div>
                    )
                  }
                </div>
              )
              :
              (<div className="noMore">{this.state.lang.noMore}</div>)
          }
        </div>
      </div>
    )
  }

  // 规则内容
  ruleComp = () => {
    return (
      <div className="rule-content-main" style={{ display: `${this.state.funcState == 2 ? 'block' : 'none'}` }}>
        <div className='rule-box' dangerouslySetInnerHTML={{ __html: this.state.lang.ruleTxt }}></div>
      </div>
    )
  }

  // 商店
  shopComp = () => {
    return (
      <div className="fragement-content-main" style={{ display: `${this.state.funcState == 3 ? 'block' : 'none'}` }}>
        <div className="fra-top">
          <div className="fra-banner">
            <div className="fra-img"></div>
            <div className="fra-desc">
              {this.state.lang.fra}：
              {
                this.state.chip == -1 ? (
                  <img src="/img/other/loading.gif" alt="" />
                ) : (
                  this.state.chip
                )
              }
            </div>
          </div>
        </div>
        <div className="fra-content">
          {
            this.state.shopList.map((item, index) => {
              return (
                <div className="fra-item" key={item.itemId}
                  onClick={() => { this.isShowShop(1, item.image, item.eggShopid, item.price) }}>
                  <div className="fra-box">
                    <div className="bubble"></div>
                    <div className="gift">
                      <img src={item.image} alt="" />
                    </div>
                    <div className="shadow"></div>
                  </div>
                  <div className="fra-exchange">
                    <div className="fra-pic"></div>
                    <div className="fra-num">{item.price}</div>
                  </div>
                </div>
              )
            })
          }

        </div>

        <div
          className={`fra-reminder ${this.state.shopReminder != 0 ? 'bounceAni' : ''}`}
          style={{ display: `${this.state.shopReminder != 0 ? 'flex' : 'none'}` }}>
          <div className="fra-rm-pic">
            <img src={this.state.shopGiftImage} alt="" />
          </div>
          {/* 数量控制 */}
          {/* <div className="count-box">
                <div className="reduce">-</div>
                <input type="number" className='show' />
                <div className="add">+</div>
              </div> */}
          <div className="desc">
            <span>{this.state.lang.isExchange}</span>
          </div>
          <div className="fra-comfirm">
            <div className="no" onClick={() => { this.isShowShop(0) }}>{this.state.lang.no}</div>
            <div className="h"></div>
            <div className="yes" onClick={() => { this.exchangeGift(this.state.eggShopId) }}>{this.state.lang.yes}</div>
          </div>
        </div>
      </div>
    )
  }

  // 大奖
  prizeRuleComp = () => {
    return (
      <div className="rule-big-prize-main" style={{ display: `${this.state.funcState == 4 ? 'block' : 'none'}` }}>
        <div className="prize-rule-box" dangerouslySetInnerHTML={{ __html: this.state.lang.prizeRuleTxt }}></div>
      </div>
    )
  }

  // 大奖弹框
  prizePopUpComp = () => {
    const isShow = this.state.isBigPrize && this.state.isBigPrizeMain
    return (
      <div className="big-prize-tip" style={{ display: `${isShow ? 'block' : 'none'}` }}
        onClick={() => {
          this.setState({
            isBigPrize: false,
            isBigPrizeMain: false
          })
        }}>
        <div className="big-prize-pic">
          <div className="circle">
            <img src="/img/app/gashapon/light.png" alt="" />
          </div>
          <div className="prize-img">
            <img src={this.state.bigPrizeImage} alt="" />
          </div>
        </div>
        <div className="big-prize-desc">
          {this.state.lang.congratulate}
        </div>
      </div>
    )
  }

  // 资源
  sourceComp = () => {
    return (
      <div className="hide">
        <img src="/img/app/gashapon/title.png" alt="" />
        <img src="/img/app/gashapon/rw_bg.png" alt="" />
        <img src="/img/app/gashapon/1.png" alt="" />
        <img src="/img/app/gashapon/2.png" alt="" />
        <img src="/img/app/gashapon/3.png" alt="" />
        <img src="/img/app/gashapon/fragment.png" alt="" />
        <img src="/img/app/gashapon/close.png" alt="" />
        <img src="/img/app/gashapon/banner.png" alt="" />
        <img src="/img/app/gashapon/egg5.png" alt="" />
        <img src="/img/app/gashapon/music_2.png" alt="" />
        <img src="/img/other/loading.gif" alt="" />
      </div>
    )
  }

  render() {
    const { lang, language, funcState } = this.state

    return (
      <div className={`gashapon-main-wrap ${isRtl(language) ? 'gashapon-ar' : ''}`}>
        {/* <div>
          概率金额调试（总金币）
          <button onClick={() => this.testEgg(1, 10)} style={{ width: '1rem', height: '1rem', fontSize: '0.4rem' }}>1-10</button>
          <button onClick={() => this.testEgg(1, 50)} style={{ width: '1rem', height: '1rem', fontSize: '0.4rem' }}>1-50</button>
          <button onClick={() => this.testEgg(2, 10)} style={{ width: '1rem', height: '1rem', fontSize: '0.4rem' }}>2-10</button>
          <button onClick={() => this.testEgg(2, 50)} style={{ width: '1rem', height: '1rem', fontSize: '0.4rem' }}>2-50</button>
        </div> */}

        {/* 资源加载 */}
        {this.sourceComp()}

        {/* 播放 */}
        <div className={`play-icon ${this.state.playMusic ? "play-circle" : ""}`} onClick={() => { this.changePlay(); }}>
          <img src={`${this.state.playMusic ? "/img/app/gashapon/music_2.png" : "/img/app/gashapon/music_1.png"}`} alt="" />
        </div>
        <audio loop autoPlay src="/img/app/gashapon/bg.mp3" ref={(audio) => { this.audioValue = audio }}></audio>
        <audio src="/img/app/gashapon/music.mp3" ref={(audio) => { this.audioValue2 = audio }}></audio>

        {/* 开始一局游戏加载icon */}
        {/* <div className="load-gif" style={{ display: `${this.state.loadGif ? 'block' : 'none'}` }}></div> */}
        <LoadingComp show={this.state.loadGif} />
        <div style={{ display: `${this.state.loadGif ? 'block' : 'none'}` }} className="loading-popUp"></div>

        {/* 第一次加载动画 */}
        <LoadingComp show={this.state.loadingPopUp} />
        <div style={{ display: `${this.state.loadingPopUp ? 'block' : 'none'}` }} className="loading-popUp"></div>

        {/* 提示 */}
        <ToastColor color={this.state.popUpColor} ref="toast" toastContent={this.state.popUpTips} />

        {/* 开始游戏后禁用操作 */}
        <div className="disable-mask" style={{ display: `${this.state.isLoading ? 'block' : 'none'}` }}></div>

        {/* 大奖模块 */}
        {this.jackPotHeaderComp()}

        {/* 主体模块 */}
        {this.gashaponContentMainComp()}

        {/* 弹框功能 */}
        <div
          className={`gashapon-reminder ${this.state.funcState != 0 ? 'bounceAni' : ''}`}
          style={{ display: `${this.state.funcState != 0 ? 'block' : 'none'}` }}>

          {/* 关闭按钮 */}
          <div className="close" onClick={() => { this.onChangeFuncState(0) }}></div>

          {/* 标题 */}
          {this.popUpTitleComp()}

          {/* 抽奖记录内容 - 1 */}
          {this.state.funcState == 1 && this.recordComp()}

          {/* 规则内容 - 2 */}
          {this.ruleComp()}

          {/* 商店内容 - 3 */}
          {this.shopComp()}

          {/* 大奖规则内容 - 4 */}
          {this.prizeRuleComp()}

          {/* 大奖排行 - 5 */}
          <RankView
            funcState={funcState}
            rankingList={this.state.rankingList}
            prizeImage={this.state.bigPrizeImage}
          />

          {/* 奖励列表 - 6 */}
          <RewardView
            funcState={funcState}
            position2={this.state.position2}
            lang={lang}
            poolLevelShow={this.state.poolLevelShow}
            normalList={this.state.normalList}
            deluxeList={this.state.deluxeList}
            changePoolLevel={(val, bool) => { this.changePoolLevel(val, bool) }}
          />
        </div>

        {/* 开奖弹框 */}
        <ResultPopUp
          lang={lang}
          isShowResult={this.state.isShowResult}
          onChangeIsShowResult={this.onChangeIsShowResult.bind(this, false)}
          resultList={this.state.resultList}
        />

        {/* 中大奖弹框 */}
        {this.prizePopUpComp()}

        {/* 遮罩 */}
        <div className="gashapon-mask" style={{ display: `${funcState != 0 || this.state.isShowResult ? 'block' : 'none'}` }}></div>

      </div >
    )
  }
}


// WEBPACK FOOTER //
// src/pages/app/gashapon/index.js